module.exports = "/static/assets/4fbcf2c035110247216ce61d5f7429fc.png";